import {createAsyncThunk} from '@reduxjs/toolkit'

import {PAY} from '@web/core/urls'
import {changeBrowserLocation} from '@web/helpers/browser'

import {LocationChangeHistoryParam, NavigationResult, ThunkApi} from '../interfaces'

const MEMBER_REFUND_URL = `${PAY}/member/refund`

/** 환불정산액 화면 이동 */
const navigateToMemberRefund = createAsyncThunk<NavigationResult, LocationChangeHistoryParam | void, ThunkApi<unknown>>(
    'navigateTo/member/refund',
    (params) => {
        const {historyType = 'PUSH'} = params ?? {}
        changeBrowserLocation({url: MEMBER_REFUND_URL, type: historyType})
    },
)

export default navigateToMemberRefund
